import * as styles from 'styles/pages/Styleguide.css'
import Anchor from 'components/atoms/navigation/Anchor'
import SGModules from 'components/utils/styleguide/SGModules'
import SGTables from 'components/utils/styleguide/SGTables'
import SGFormFields from 'components/utils/styleguide/SGFormFields'

const SGMolecules = () => (
  <Anchor placement='molecules'>

    <Anchor placement='molecules_post_input'>
      <h2 className={ styles.sgHeading }>Post Input</h2>
      <SGFormFields />
    </Anchor>

    <Anchor placement='molecules_modules'>
      <h2 className={ styles.sgHeading }>Modules</h2>
      <SGModules />
    </Anchor>

    <Anchor placement='molecules_tables'>
      <h2 className={ styles.sgHeading }>Tables</h2>
      <SGTables />
    </Anchor>

  </Anchor>
)

export default SGMolecules
